import { LinkButton } from '@unowmooc/react-ui-kit'
import I18nProvider from '@unowmooc/i18n'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import React from 'react'
import { useCourseContext } from 'modules/course/components/CourseContext/CourseContext'
import styled from '@emotion/styled'

const CtaStyled = styled.div`
  margin: 22px 0;
`

const CtaProgram = () => {
  const { slugCourse, sessionId, courseIdentifier, sessionIdentifier } = useCourseContext()

  return (
    <CtaStyled>
      <LinkButton
        tag={Link}
        to={I18nProvider.getLinkRoute('/courses/{slugCourse}/{sessionId}/program', {
          slugCourse,
          sessionId,
        })}
        data-tracking-id="restitution.click_on_program_button_link"
        data-tracking-values={JSON.stringify({
          courseIdentifier,
          sessionIdentifier,
        })}
      >
        <FormattedMessage id="courses.course.skills.cta_program_label" />
      </LinkButton>
    </CtaStyled>
  )
}

export default CtaProgram
